import { useEffect, useState } from 'react'
import AssetStatus from '../../Components/Home/AssetStatus'
import ContentBarChart from '../../Components/Home/ContentBarChart'
import ContentCategory from '../../Components/Home/ContentCategory'
import MyDashboard from '../../Components/Home/MyDashboard'
import RecentActivity from '../../Components/Home/RecentActivity'
import { API_CONFIG, API_LIST } from '../../Constants/ApiDefinations'
import { objectToQueryString } from '../../Helpers/Util'
import updateTagMetaData from '../../Helpers/updateTagMetaData'
import mainApiService from '../../Services'
import { useAppDispatch, useAppSelector } from '../../Store/Hooks'
import { selectContentCategories } from '../../Store/Slice/appConfig.slice'
import { setLoader } from '../../Store/Slice/loader.slice'
import './home.scss'

function Home() {
  const dispatch = useAppDispatch()
  const contentCategories = useAppSelector(selectContentCategories)
  const { cmsConfig } = useAppSelector((state) => state.appConfig)

  const [assetStatusData, setAssetStatusData] = useState<any>([])
  const [metaCategoryList, setmetaCategoryList] = useState([])

  const getHomepageData = async () => {
    const payload = {
      assetStatus: 'TRUE',
      contentCategories: 'TRUE',
      assetType: 'TRUE',
      publishedAssets: 'TRUE',
      ingestionStatusCounts: 'TRUE',
    }
    const paramsData = objectToQueryString(payload)

    dispatch(setLoader(true))
    const requestedData = API_CONFIG(API_LIST.DASHBOARD_API.GET_HOME_PAGE, null, null, paramsData)
    const result: any = await mainApiService(requestedData)

    dispatch(setLoader(false))
    if (result?.responseCode === 200) {
      setAssetStatusData(result?.data)
    }
  }

  useEffect(() => {
    getHomepageData()
    updateTagMetaData({ title: 'Homepage' })
    return () => {
      updateTagMetaData({})
    }
  }, [])

  useEffect(() => {
    const fetchMetaCategoryList = async () => {
      const metaCatoryCopy: any = []
      const requestedData = API_CONFIG(
        API_LIST.SYSTEM_CONFIGURATION.MASTER_LIST,
        {},
        null,
        'keyName=CONTENT_CATEGORY',
      )
      const result: any = await mainApiService(requestedData)
      result?.data?.forEach((ele: any) => {
        let key = ele.key
        if (key === 'INDEPENDENT_VOD_ASSETS') {
          key = 'Independent VOD'
        } else if (key === 'NON_VOD_ASSETS') {
          key = 'Non VOD'
        }
        metaCatoryCopy.push({
          value: ele.key,
          key: key,
        })
      })
      setmetaCategoryList(metaCatoryCopy)
    }
    fetchMetaCategoryList()
  }, [contentCategories])

  const isBarChartEnabled = cmsConfig?.ENABLED_FEATURES?.HOME_BAR_CHART

  return (
    <div className='homepage-wrapper'>
      <div className='mb-2'>
        <MyDashboard />
      </div>
      <div className='mb-2'>
        <AssetStatus homepageData={assetStatusData} />
      </div>
      <div
        className={`d-flex column-gap-20 charts-recent-wrapper ${
          isBarChartEnabled ? 'mh-1150' : 'mh-595'
        }`}
      >
        <div className='d-flex gap-20 direction-column w-60'>
          <ContentCategory
            homepageData={assetStatusData?.contentCategories}
            metaCategoryList={metaCategoryList}
          />
          {isBarChartEnabled && (
            <ContentBarChart jobstatus={assetStatusData?.ingestionStatusCounts} />
          )}
        </div>
        <RecentActivity />
      </div>
      {/* <div className='d-flex column-gap-20 mb-2'>
      <AssetType />
      <PublishedAsset />
    </div> */}
    </div>
  )
}

export default Home
